import styled from "styled-components";

export const FormWrapper = styled.div`
  margin: 24px;
  width: 360px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TextFieldWrapper = styled.div`
  margin-bottom: 12px;
`;
